import React from "react";
import {Brands} from "@core-ui/utility";
import {useTheme} from "@core-ui/react-stitch";
import {Icon} from "../components/Icon";
import {IconContainerProps} from "../types";

export const StarIcon = (props: IconContainerProps): JSX.Element => {
  const {fillColor} = props;
  const theme = useTheme();

  const CrossBrandSVG = (
    <svg fill="none" viewBox="0 0 14 13" xmlns="http://www.w3.org/2000/svg">
      <path
        clipRule="evenodd"
        d="M7.02697 9.38889l-4.219 3.53831 1.40821-4.98276L0 4.76725l5.07966-.0364L7.02697 0l1.89337 4.73085L14 4.76725 9.83776 7.94444 11.2431 13 7.02697 9.38889z"
        fill={fillColor || theme.color.b1 || "#000"}
        fillRule="evenodd"
      />
    </svg>
  );

  const brandIconSVGs = {
    [Brands.Athleta]: CrossBrandSVG,
    [Brands.BananaRepublic]: CrossBrandSVG,
    [Brands.BananaRepublicFactoryStore]: CrossBrandSVG,
    [Brands.Gap]: CrossBrandSVG,
    [Brands.GapFactoryStore]: CrossBrandSVG,
    [Brands.OldNavy]: CrossBrandSVG,
    crossBrand: CrossBrandSVG,
  };

  return <Icon {...props} brandIconSVGs={brandIconSVGs} />;
};
